module.exports = __webpack_public_path__ + "img/2.676ff813.svg";